import { useState } from "react";
import { toast } from "sonner";
import { api } from "@/lib/api";
import { Button } from "@/components/ui/button";
import { Label } from "@/components/ui/label";
import { Textarea } from "@/components/ui/textarea";
import { Dialog, DialogContent, DialogFooter, DialogHeader, DialogTitle } from "@/components/ui/dialog";
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "@/components/ui/select";
import { RESOLUTIONS } from "@/lib/checkins";

export const errMsg = (e) => {
  const d = e?.response?.data?.detail;
  return typeof d === "string" ? d : e?.message || "Request failed";
};

export function ResolveDialog({ alert, open, onClose, onDone }) {
  const [code, setCode] = useState("contacted_client");
  const [note, setNote] = useState("");
  const [busy, setBusy] = useState(false);
  async function save() {
    setBusy(true);
    try {
      const r = await api.post(`/checkin-alerts/${alert.id}/resolve`, { resolution_code: code, note });
      toast.success("Alert resolved");
      onDone(r.data);
      onClose();
    } catch (e) {
      toast.error("Couldn't resolve", { description: errMsg(e) });
    } finally {
      setBusy(false);
    }
  }
  return (
    <Dialog open={open} onOpenChange={(o) => !o && onClose()}>
      <DialogContent data-testid="checkin-resolve-dialog">
        <DialogHeader><DialogTitle>Resolve — {alert.category}</DialogTitle></DialogHeader>
        <div className="space-y-3">
          <div>
            <Label>Outcome</Label>
            <Select value={code} onValueChange={setCode}>
              <SelectTrigger data-testid="checkin-resolve-code"><SelectValue /></SelectTrigger>
              <SelectContent>{RESOLUTIONS.map((r) => <SelectItem key={r.value} value={r.value}>{r.label}</SelectItem>)}</SelectContent>
            </Select>
          </div>
          <div>
            <Label>Note (stays in the clinical record)</Label>
            <Textarea rows={3} value={note} onChange={(e) => setNote(e.target.value)} data-testid="checkin-resolve-note" />
          </div>
        </div>
        <DialogFooter>
          <Button variant="outline" onClick={onClose}>Cancel</Button>
          <Button onClick={save} disabled={busy} data-testid="checkin-resolve-save">Resolve</Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
}
